const placeholders = (n = 4, key = "productId"): Placeholder[] =>
  new Array(n).fill(0).map((_, i) => ({ [key]: i, placeholder: true }));

export default placeholders;
